module.exports = __webpack_public_path__ + "img/PenIcon.927d2b14.svg";